<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :to="{ name: 'New Customer' }"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-card
                flat
                tile
                min-width="100%"
            >
                <v-row class="fill-height">
                    <v-col class="pt-0 pb-0 pr-0">
                        <v-text-field
                            label="Search By Name/Address/Email/Phone"
                            filled
                            v-model="filter.keyword"
                            @keydown.enter="getCustomers"
                            dark
                            hide-details
                            background-color="#04b9e4"
                            append-icon="mdi-magnify"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="customers-count" >
                     {{ total + ' Customers Found.' }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-list two-line tile flat class="py-0">
                <v-list-item-group
                    v-model="selectedItems"
                    multiple
                >
                <template v-for="(customer, index) in customers">
                    <v-list-item
                    :key="`customer-${index}`"
                    :value="customer.id"                 
                    >
                        <template>
                            <v-list-item-content @click.stop="openCustomer(customer.id)">
                                <v-list-item-title v-html="customer.title"></v-list-item-title>
                                <v-list-item-subtitle v-html="customer.street_address + ', ' + customer.city + ', ' + customer.state + ' ' + customer.zip"></v-list-item-subtitle>
                                <div>
                                    <v-chip
                                    v-if="customer.email"
                                    class="mr-2 mb-1"
                                    color="light-blue"
                                    text-color="white"
                                    small
                                    label
                                    >
                                     {{ 'Email: ' + customer.email }}
                                    </v-chip>
                                    <v-chip
                                    v-else
                                    class="mr-2 mb-1"
                                    color="red"
                                    text-color="white"
                                    small
                                    label
                                    >
                                    No Email Entered.
                                    </v-chip>
                                </div>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-list-item-icon class="ma-0 mb-1">
                                    <v-btn small tile class="mr-1" elevation="0" color="#0298c6" dark @click.stop="openLink(customer.google_link)">
                                        <v-icon dark>mdi-map-marker</v-icon>
                                    </v-btn>

                                    <v-btn small tile class="mr-1" color="#003a6f" elevation="0" dark @click.stop="dial(customer.phone)">
                                        <v-icon dark>mdi-phone</v-icon>
                                    </v-btn>

                                    <v-btn small tile color="primary" elevation="0" dark @click.stop="sendmail(customer.email)">
                                        <v-icon dark>mdi-email</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                    <v-divider
                    :key="`dv-${index}`"
                    ></v-divider>
                </template>
                <v-list-item v-if="pagination.total > 1">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-card>
        <FilterDrawer :show="drawer" :filter="filter" :routekey="routeKey" @update-status="updateStatus" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @update-phone="updatePhone" @submit-search="submitSearch"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterDrawer from '../components/FilterDrawer.vue'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            drawer: false,
            loading: true,
            customers: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                keyword: "",
                phone: "",
                status: "active"
            },
            total: 0,
            all: [],
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        if(this.customers.length == 0) {
            this.customers = this.vcustomers

            if(this.customers.length == 0) {
                this.getCustomers()
            } else {
                this.getCustomers()
            }
        } else {
            this.getCustomers()
        }
    },
    computed: {
        ...mapGetters({
            statuses: 'data/statusArray',
            schedules: 'data/schedulesArray',
            assignitems: 'data/assignArray',
            vcustomers: 'data/customers',
        }),
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else {
                return this.pageTitle
            }
        },
    },
    components: {
        FilterDrawer
    },
    methods: {
        getCustomers() {
            this.loading = true
            this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.$store.commit('data/SET_CUSTOMERS', response.data.customers.data)
                this.customers = response.data.customers.data
                this.pagination.current = response.data.customers.current_page
                this.pagination.total = response.data.customers.last_page
                this.total = response.data.customers.total
                this.all = response.data.all
                this.stats = response.data.stats
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getCustomers()
            this.$vuetify.goTo(0)
        },
        openCustomer(id) {
            this.$router.push({ path: '/customer/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        openLink (link) {
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateStatus(val) {
            this.filter.status = val
            this.getCustomers()
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updatePhone(val) {
            this.filter.phone = val
        },
        submitSearch() {
            this.getCustomers()
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff

.fullscreen
    background: #fff
    height: 100%

.w-100
    width: 100%
    .v-btn 
        width: 100%

.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px

.v-chip 
    border-radius: 0!important

.customers-count
    font-size: 14px
</style>